import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { HowToWinTutorialComponent } from '@app/components/how-to-win-tutorial/how-to-win-tutorial.component';

@Component({
  selector: 'bingo-how-to-play-dialog',
  imports: [HowToWinTutorialComponent, MatButton],
  templateUrl: './how-to-play-dialog.component.html',
  styleUrl: './how-to-play-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowToPlayDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<HowToPlayDialogComponent>);

  protected closeDialog(): void {
    this.dialogRef.close();
  }
}
